import { Theme } from '@mui/material';
import { makeStyles } from '@mui/styles';
import React from 'react';
import Colors from '../../utils/color';
import { HITL3_PADDING } from '../../utils/hitl3Spacing';
import IntentsSectionGrouped from './IntentsSectionGrouped';
import { OmniBarCompact } from './OmniBarCompact';

const useStyles = makeStyles<Theme>(() => ({
  bar: {
    display: 'flex',
    alignItems: 'stretch',
    // One flush white section like the three panes above; a single hairline
    // separates it from them, replacing the porcelain gap that used to sit here.
    backgroundColor: Colors.white,
    borderTop: `1px solid ${Colors.alto}`,
    // Shared 8px inset on all sides.
    padding: HITL3_PADDING,
  },
  quickResponse: {
    // Grows to fill the leftover width between the Conversation and Order Flow
    // groups. No card frame — the OmniBar input carries its own border; this is
    // just a flex sizing wrapper.
    flex: '1 1 0',
    minWidth: 280,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
  },
  inputWrap: {
    flex: 1,
    display: 'flex',
    alignItems: 'center',
    minWidth: 0,
  },
}));

/**
 * Full-width bottom action bar.
 *
 * IntentsSectionGrouped lays out the bar left→right: Escalation (Request Staff),
 * Conversation, then the QUICK RESPONSE OmniBar, then Order Flow (Continue /
 * Confirm / Read Back / Complete) and any trailing "More" group. The OmniBar is
 * passed in as a slot so it sits between the Conversation and Order Flow groups
 * (all share IntentsSectionGrouped's flex row) while its input styling stays here.
 */
const BottomActionBar = () => {
  const classes = useStyles();

  return (
    <div className={classes.bar}>
      <IntentsSectionGrouped
        omniBar={
          <div className={classes.quickResponse}>
            <div className={classes.inputWrap}>
              <OmniBarCompact />
            </div>
          </div>
        }
      />
    </div>
  );
};

export default BottomActionBar;
